/**
 * Sentinel value used to signal auto-pause from an in-flight file's
 * tus.onError back to `launchWorker` (bug fix 2026-08).
 *
 * Rationale: `rejectOne(err)` would propagate to launchWorker's catch, set
 * `terminalError = err`, and `throw err` — killing every worker in the
 * pool. Resume then had no worker to wake up. Resolving with this sentinel
 * instead lets launchWorker treat the pair as "needs requeue when resume
 * happens" without touching terminalError.
 *
 * Kept in its own file because both `upload()` and `resume()` paths need
 * to build + detect the sentinel, and duplicating the shape (or comparing
 * literals inline) would drift between the two paths.
 */

export const AUTO_PAUSE_SENTINEL_KEY = "__autoPaused";

/**
 * @param {{ expected: object, file: File }} pair
 * @returns {{ __autoPaused: true, pair: {expected: object, file: File} }}
 */
export const buildAutoPauseSentinel = (pair) => ({
  [AUTO_PAUSE_SENTINEL_KEY]: true,
  pair,
});

/**
 * @param {any} value  the resolved value from runOne
 * @returns {boolean}
 */
export const isAutoPauseSentinel = (value) =>
  !!value &&
  typeof value === "object" &&
  value[AUTO_PAUSE_SENTINEL_KEY] === true;
